// animatedLoops/flag.js
//
// Self-contained build-time feature flag for the Animated Loop / GIF library.
// Defaults OFF: when OFF, the picker is byte-identical to today — no "Animated"
// wallpaper tab, no "Loops" media source, nothing reads or writes a loop value.
// Flip per environment with REACT_APP_ANIMATED_LOOP_LIBRARY=true (or 1).
//
// Kept local to this module (like backgroundPatterns/flag.js) so it does not
// collide with the parallel wallpaper-library work that also touches
// src/constants. At merge it can fold into constants/featureFlags.js if desired.

const truthy = (v) => v === "true" || v === "1" || v === true;

export const ANIMATED_LOOPS_ENABLED = truthy(
  process.env.REACT_APP_ANIMATED_LOOP_LIBRARY
);
